/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/23 10:28
 * @FileName: home.js
 * @LastEditor: 2022/9/23 10:28
 * @Name: home
 */

const home = {
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        isShowHeader: true,
        isShowLeftSider: true
      },
      component: () => import('@/project/views/home/home.vue')
    },
    {
      path: '/businessArticle',
      name: 'businessArticle',
      meta: {
        isShowHeader: true,
        isShowLeftSider: true
      },
      component: () => import('@/project/views/home/businessArticle.vue')
    }
  ]
}
export default home




// WEBPACK FOOTER //
// ./src/project/router/home.js